module.exports = __webpack_public_path__ + "img/sumary_house_load.42e911d1.svg";